import type { BoxProps } from '@mui/material/Box';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { UploadIllustration } from 'src/assets/illustrations';
import { useTranslate } from 'src/locales';
// ----------------------------------------------------------------------

export function UploadPlaceholder({ ...other }: BoxProps) {
  const { t: tCommon } = useTranslate('common');
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
      {...other}
    >
      <UploadIllustration hideBackground sx={{ width: 200 }} />

      <Stack spacing={1} sx={{ textAlign: 'center' }}>
        <Box sx={{ typography: 'h6' }}>{tCommon('dropOrSelectFile')}</Box>
        <Box sx={{ typography: 'body2', color: 'text.secondary' }}>
          {tCommon('dropFilesHereOrClickTo')}
          <Box
            component="span"
            sx={{ mx: 0.5, color: 'primary.main', textDecoration: 'underline' }}
          >
            {' '}
            {tCommon('browse')}{' '}
          </Box>
          {tCommon('throughYourMachine')}
        </Box>
      </Stack>
    </Box>
  );
}
